import { useEffect, useState } from "react";
import {
  tokenSecondsLeft,
  type MMUserSessionType,
} from "../../../auth/messagemedia";
import { authStrategy } from "./../../../auth/index";

export const useMmToken = (refresh = true): string | undefined => {
  const [session, setSession] = useState<{
    accessToken?: string;
    refreshToken?: string;
    expireIn?: number;
    createdAt?: number;
  }>();

  useEffect(() => {
    let refreshTimeout: NodeJS.Timeout;
    if (!session) {
      authStrategy.getSession().then(setSession);
    } else if (refresh) {
      const refreshTimeInSeconds =
        session.createdAt && session.expireIn
          ? tokenSecondsLeft(session as MMUserSessionType) - 2
          : 120;

      refreshTimeout = setTimeout(() => {
        authStrategy.getSession().then(setSession);
      }, refreshTimeInSeconds * 1000);
    }
    return () => refreshTimeout && window.clearTimeout(refreshTimeout);
  }, [refresh, session]);

  useEffect(() => {
    const unsubscribe = authStrategy.onTokenUpdate(() =>
      authStrategy.getSession().then(setSession)
    );

    return unsubscribe;
  }, []);

  return session?.accessToken;
};
